import Header from "../../Components/Header/index"
import Card from "../../Components/cards"
import Gif from "../../Components/gif"
import "./homepage.css"


function HomePage() {
    return (
        <main className="main">
            <Header />
            <Gif></Gif>
            <Card />
        </main>

    )
}

export default HomePage